<template>
	<div>
		<mensajeSistema></mensajeSistema>
		<v-row dense>
			<v-col cols="12" class="d-flex justify-space-around">
				<v-card outlined>
					<v-card-text>
						<div ref="top-tooltip">
							<div class="d-flex justify-start">
								Preguntas correctas: {{ tooltipContent.rights }}
							</div>
							<div class="d-flex justify-start">
								Preguntas incorrrectas: {{ tooltipContent.total_questions - tooltipContent.rights }}
							</div>
							<div class="d-flex justify-start">
								Total de preguntas: {{ tooltipContent.total_questions }}
							</div>
						</div>
					</v-card-text>
				</v-card>
				<!-- separation -->
				<v-card outlined>
					<v-card-text>
						<div ref="top-tooltip">
							<div class="d-flex justify-center">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-badge class="primary--text" icon="fas fa-info">
											<v-btn color="primary" small text v-on="on" v-bind="attrs">
												{{ tooltipContent.title }}
											</v-btn>
										</v-badge>
									</template>
									<span>Promedio general de todas las pruebas del estudiante</span>
								</v-tooltip>
							</div>
							<!-- nota numérica -->
							<!-- <div class="d-flex justify-center">
								{{  10 > Math.round(tooltipContent.promedio)? '0' + Math.round(tooltipContent.promedio) :
									Math.round(tooltipContent.promedio) }}
							</div> -->
							<div class="d-flex justify-center text-h4 font-weight-bold">{{
								convertToLiteral(tooltipContent.promedio) }}</div>
							<!-- <p>{{ tooltipContent.results }}</p> -->
						</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-container v-resize="resizeChart">
				<!-- <div class="axis-label y-axis-label">Eje vertical: Representación de las notas del 1 al 20</div> -->
				<div ref="chartContainer" style="width: 100%; height: 400px;"></div>
				<!-- <div class="axis-label x-axis-label">Eje horizontal: Fechas en las que los exámenes fueron rendidos</div> -->
			</v-container>
			<div ref="tooltip" class="floating-tooltip-2"></div>
			<v-col cols="12">
				<div class="switcher">
					<button v-for="interval in intervals" :key="interval"
						:class="['switcher-item', { 'switcher-active-item': currentInterval === interval }]"
						@click="syncToInterval(interval)">
						{{ interval }}
					</button>
				</div>
			</v-col>
			<!-- <v-col>
				<div class="">EJE VERTICAL: Representación de las notas del 1 al 20</div>
				<div class="">EJE HORIZONTAL: Fechas en las que los exámenes fueron rendidos</div>
			</v-col> -->
		</v-row>



		<!-- tooltip superior -->





		<!-- VISOR DE RESULTADOS -->
		<v-dialog v-model="dialogResultados" scrollable max-width="600px">
			<v-card>
				<v-card-title class="modal_title">
					<v-icon dark left>fas fa-layer-group</v-icon>
					Mis resultados
					<v-spacer></v-spacer>
					<v-tooltip bottom color="#1b1b1b">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" fab dark x-small class="btn_style4 mr-1" @click="verRptas = !verRptas">
								<v-icon>fa-eye</v-icon>
							</v-btn>
						</template>
						<span>{{ verRptas ? 'Ver mis respuestas' : 'Ver respuestas correctas' }}</span>
					</v-tooltip>
					<v-btn fab dark x-small class="btn_style3" @click="dialogResultados = false">
						<v-icon dark>fa-times</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="height: 500px">
					<br />
					<v-expansion-panels v-model="panels" multiple>
						<!-- <v-icon color="error"> mdi-alert-circle </v-icon> -->

						<v-expansion-panel v-for="(Misrespuestas, index) in misRespuestasResultados"
							:key="Misrespuestas.idpregunta">

							<v-expansion-panel-header disable-icon-rotate class="pb-0">
								<div>
									<li style="margin-left: 15px" v-html="'<strong class=claseforzada>' +
										(index + 1) +
										')</strong><br/>' +
										Misrespuestas.pregunta
										"></li>
								</div>
								<template v-slot:actions>
									<v-icon right size="30" :color="Misrespuestas.valor_pregunta ? 'teal' : 'red'">
										{{
											Misrespuestas.valor_pregunta ? "fas fa-check " : "fas fa-times "
										}}
									</v-icon>
								</template>
							</v-expansion-panel-header>
							<div v-if="!Misrespuestas.valor_pregunta" class="d-flex pb-4 mx-10">
								<a style="color:red;" @click="verClase(Misrespuestas.idtema)"
									class="text-decoration-none">
									<v-icon color="error" small left>fas
										fa-book-open</v-icon>
									<div style="font-weight:bold;display: inline;">Ir a repasar
										unidad :</div> {{ Misrespuestas.nombre_clase }}
								</a>
							</div>
							<v-divider></v-divider>
							<v-expansion-panel-content>
								<v-list shaped>
									<v-list-item-group color="primary" active-class="border-in">
										<v-subheader class="d-flex justify-space-between">
											<strong>
												<v-icon>far fa-question-circle</v-icon>
												{{ verRptas ? 'Respuestas correctas:' : 'Mis respuestas:' }}
											</strong>
											<small class="pa-5"> <i> {{
												Misrespuestas.tipo_pregunta == 'res_mul'
													? 'Respuesta multiple'
													: Misrespuestas.tipo_pregunta == 'res_uni'
														? 'Respuesta unica'
														: 'Respuesta verdaderos - falso'
											}} </i> </small>
										</v-subheader>
										<template v-if="verRptas">
											<v-list-item v-for="nestedRespuestas in Misrespuestas.respuestas_marcadas"
												:key="nestedRespuestas.idresdpuesta">
												<v-list-item-icon>
													<v-icon :color="nestedRespuestas.valor_respuesta ? 'green' : 'red'"
														dark>
														{{ nestedRespuestas.valor_respuesta ? "fas fa-check" :
															"fas fa-times" }}
													</v-icon>
												</v-list-item-icon>

												<v-list-item-content>
													<v-list-item-title>
														<li v-html="nestedRespuestas.respuesta"></li>
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>

										</template>

										<template v-else>
											<v-list-item v-for="nestedRespuestas in Misrespuestas.respuestas_marcadas"
												:key="nestedRespuestas.idresdpuesta">
												<v-list-item-icon>
													<v-icon :color="nestedRespuestas.valor_respuesta_marcada ? 'green' : 'red'
														" dark>{{
															nestedRespuestas.valor_respuesta_marcada
																? "fas fa-check"
														: "fas fa-times"
														}}</v-icon>
												</v-list-item-icon>

												<v-list-item-content>
													<v-list-item-title
														:class="nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false && nestedRespuestas.valor_respuesta_marcada == true ? 'cruz' : ''">
														{{ nestedRespuestas.respuesta }}
													</v-list-item-title>
												</v-list-item-content>
												<v-list-item-action>
													<v-tooltip left color="error" v-if="(nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
														nestedRespuestas.valor_respuesta_marcada == true) || (nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
															nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
															'res_mul')">
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon color="error" dark v-bind="attrs" v-on="on">
																<v-icon color="error">mdi-information</v-icon>
															</v-btn>
														</template>
														<span> {{
															nestedRespuestas.valor_respuesta == false &&
																Misrespuestas.valor_pregunta == false &&
																nestedRespuestas.valor_respuesta_marcada == true
																? "Respuesta Incorrecta"
																: nestedRespuestas.valor_respuesta == true &&
																	Misrespuestas.valor_pregunta == false &&
																	nestedRespuestas.valor_respuesta_marcada == false &&
																	Misrespuestas.tipo_pregunta ==
																	'res_mul' ? "Faltó marcar esta respuesta" : ""
														}}</span>
													</v-tooltip>
												</v-list-item-action>
											</v-list-item>
										</template>

									</v-list-item-group>
								</v-list>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<b>CALIFICACIÓN:</b>
					<v-chip class="ma-2" :color="resultadoVerExamen == 'APROBADO'
						? 'green accent-4'
						: 'red accent-4'
						" text-color="white">
						<v-avatar left :class="resultadoVerExamen == 'APROBADO' ? 'green darken-4' : 'red'
							">
							{{ notaPeru }}
						</v-avatar>
						{{ resultadoVerExamen }}
					</v-chip>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>


<script>
import axios from "@/helpers/axios";

import { createChart } from 'lightweight-charts'; //PriceScaleMode
import { mapMutations } from "vuex"; //mapGetters, mapActions


export default {
	name: 'TradingChart',
	props: {
		dataGraph: {
			type: Array,
			default: () => []
			// required: true
		},

		weekData: {
			type: Array,
			// required: true
		},

		monthData: {
			type: Array,
			// required: true
		},

		yearData: {
			type: Array,
			// required: true
		},

		intervals: {
			type: Array
		},

		seriesesData: {
			type: Map
		},

		currentInterval: {
			type: String
		},

	},
	data() {
		return {
			dialogResultados: false,
			verRptas: false,
			panels: [0, 1, 2, 3, 4],
			misRespuestasResultados: [],
			resultadoVerExamen: null,
			notaPeru: null,

			tipo_contenido: null,
			chart: null,
			series: null,
			// intervals: ['1D', '1W', '1M', '1Y'],
			// currentInterval: '1D',
			additionalDataMap: new Map(),

			tooltipContent: {
				title: 'Promedio de notas',
				promedio: '',
				promedio_literal: '',
				results: '',
				rights: '',
				total_questions: ''
			},

		};
	},
	mounted() {

		this.chart = createChart(this.$refs.chartContainer, {
			autoSize: true,
			// watermark: {
			// 	visible: true,
			// 	fontSize: 30,
			// 	horzAlign: 'left',
			// 	vertAlign: 'bottom',
			// 	color: 'rgba(171, 71, 188, 0.5)',
			// 	text: 'Gada Industries',
			// },
			width: this.$refs.chartContainer.offsetWidth,
			height: 400,
			layout: {
				background: {
					type: 'solid',
					color: '#ffffff',
					// color: '#000000',
				},
				textColor: '#404040',
				// textColor: '#d1d4dc',
			},
			localization: {
				priceFormatter: function (price) {
					if (price < 0 || price > 20) return ""
					if (!Number.isInteger(Number(price))) return price.toFixed(2);
					if (Number(price) || price == 0) return price;
					console.error(`${price} no es un formato válido`);
				},
			},
			grid: {
				vertLines: {
					visible: true,
					// color: 'rgba(200, 200, 200, 0.7)',
				},
				horzLines: {
					// visible: false,
					color: 'rgba(200, 200, 200, 0.7)',
					// color: 'rgba(42, 46, 57, 0.5)',
				},
			},
			// overlayPriceScales: {
			// 	// autoScale: false,
			// 	mode: 2,
			// 	// borderVisible: false,
			// 	minimumWidth: 10,
			// 	alignLabels: false,
			// },
			rightPriceScale: {
				borderVisible: false,
			},
			timeScale: {
				borderVisible: false,
				timeVisible: true,
				secondsVisible: true,
				ticksVisible: true
			},
			kineticScroll: {
				touch: false,
				mouse: false
			},
			handleScale: {
				// zoom con el mouse scroll
				// mouseWheel: true,
				// pinch: false,
				// axisPressedMouseMove : false  // se puede usar tambièn AxisPressedMouseMoveOptions. first find out how to use it
			},
			crosshair: {
				horzLine: {
					visible: false,
				},
			},
			leftPriceScale: {
				visible: true,
				borderColor: 'rgba(197, 203, 206, 1)',
			},
		});

		this.chart.priceScale('left').applyOptions({
			scaleMargins: {
				top: 0.1,
				bottom: 0.01,
			},
			autoScale: false, // not sure w it ds
			ticksVisible: true,
			// minimumWidth: 300,
			// alignLabels: false,
		});


		this.syncToInterval(this.currentInterval);
		this.setupTooltip();
		// this.addAutomaticTimeScaleMarkers(); 
	},
	watch: {
		dataGraph(newVal) {
			this.limpiarData();
			if (newVal) {
				this.syncToInterval(this.currentInterval);
				this.setupTooltip();
				let dataChart = this.dataGraph.map(obj => {
					const date = new Date(obj.fecha_creacion);
					const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
					const time = Math.floor(utcDate.getTime() / 1000);
					this.additionalDataMap.set(time, {
						codigo: obj.codigo,
						time: time,
						verdaderas: obj.verdaderas,
						cantidad_preguntas: obj.cantidad_preguntas
					})

					return {
						...obj,
						time: time,
						value: obj.verdaderas / obj.cantidad_preguntas
					}
				})
				this.seriesesData.set(this.currentInterval, dataChart);
				// this.addAutomaticTimeScaleMarkers();
			}
		}
	},

	methods: {


		...mapMutations("mensajeSis", ["setEnviarMens"]),


		resizeChart() {
			if (this.chart) {
				this.chart.resize({
					width: this.$refs.chartContainer.offsetWidth // Actualiza el ancho de la gráfica al cambiar el tamaño del contenedor
				});
			}
		},

		syncToInterval(interval) {
			if (this.series) {
				this.chart.removeSeries(this.series);
				this.series = null;
			}

			//se cambio de addAreaSeries a addLineSeries para poder usar timeScale
			this.series = this.chart.addLineSeries({

				topColor: 'rgba(76, 175, 80, 0.56)',
				bottomColor: 'rgba(76, 175, 80, 0.04)',
				lineColor: '#76B947',
				lineWidth: 4,
				priceScaleId: 'left',
			});

			const timeScale = this.chart.timeScale();

			timeScale.fitContent();
			// code up 

			if (this.series && this.seriesesData.has(interval)) {
				this.series.setData(this.seriesesData.get(interval));

			}

			this.updateInterval(interval);


			//aqui va el método para actualizar valores del tooltip superior
			this.calculateValuesTopTooltip();

			this.chart.subscribeClick((param) => {
				if (param.seriesData) {
					const seriesPrice = param.seriesData.get(this.series);
					if (seriesPrice) {
						const additionalData = this.additionalDataMap.get(param.time);
						if (additionalData) {
							this.onSeriesClick(additionalData);
						}
					}
				}
			});



		},


		setupTooltip() {
			this.chart.subscribeCrosshairMove((param) => {
				const tooltip = this.$refs.tooltip;
				if (
					param.point === undefined ||
					!param.time ||
					param.point.x < 0 ||
					param.point.x > this.$refs.chartContainer.clientWidth ||
					param.point.y < 0 ||
					param.point.y > this.$refs.chartContainer.clientHeight
				) {
					tooltip.style.display = 'none';
				} else {

					//added last
					const toolTipWidth = 80;
					const toolTipHeight = 100;
					const toolTipMargin = 15;

					// const dateStr = param.time;
					// const dateStr = param.time;
					const data = param.seriesData.get(this.series);

					const additionalData = this.additionalDataMap.get(param.time);

					// const price = data.value;
					if (!data || !data.value) {
						tooltip.style.display = 'none';
						return;
					}
					tooltip.style.display = 'block';
					// <div style="color: rgba(0, 150, 136, 1); font-weight: bold;">Gada Inc.</div>
					tooltip.innerHTML = `
						
						<div style="color: black; margin-top: 4px;">
							${additionalData ? additionalData.verdaderas : "X"} preguntas correctas de ${additionalData ? additionalData.cantidad_preguntas : "X"}
						</div>
						`;

					const y = param.point.y;
					let left = param.point.x + toolTipMargin;
					if (left > this.$refs.chartContainer.clientWidth - toolTipWidth) {
						left = param.point.x - toolTipMargin - toolTipWidth;
					}

					let top = y + toolTipMargin;
					if (top > this.$refs.chartContainer.clientHeight - toolTipHeight) {
						top = y - toolTipHeight - toolTipMargin;
					}
					tooltip.style.left = left + 'px';
					tooltip.style.top = top + 'px';
				}
			});
		},


		//828 alpha  ,  837 gama
		async verRespuestasResultados(tipo_contenido, idexamen, idusuario) {
			const me = this;
			let URI;
			this.tipo_contenido = tipo_contenido
			if (tipo_contenido == 0) {
				URI = `/simulador/simuladorExamenColegio/simuladorAdmDetalles/simuladorAdmDE/listarAdmPdetalleResultados/${idusuario}/lista/${idexamen}`
			} else {
				URI = `/simulador/simuladorExamen/simuladorDetalles/simuladorDE/listarPdetalleResultados/${idusuario}/lista/${idexamen}`
			}

			try {
				const response = await axios.get(URI);

				const datosRespuestas = response.data.map((number) => {
					return {
						idtema: number.idtema,
						nombre_clase: number.nombre_clase,
						idexamen: number.idexamen,
						idpregunta: number.idpregunta,
						pregunta: number.pregunta,
						tipo_pregunta: number.tipo_pregunta,
						valor_pregunta: number.valor_pregunta,
						respuestas: number.respuestas,
						respuestas_marcadas: number.respuestas_marcadas,
					};
				});

				me.misRespuestasResultados = datosRespuestas;


				let buenas = 0;
				let totalRptas = 0;
				datosRespuestas.forEach((element) => {
					totalRptas++;
					if (element.valor_pregunta) {
						buenas++;
					}
				});

				let result = (buenas * 100) / totalRptas;
				let resultNotaPeru = (result * 20) / 100;
				me.notaPeru = Math.round(resultNotaPeru);
				if (result >= 60) {
					me.resultadoVerExamen = "APROBADO";
				} else {
					me.resultadoVerExamen = "DESAPROBADO";
				}

				me.dialogResultados = true;
			} catch (e) {
				(console.error || console.log).call(console, e.stack || e);
			}
		},


		onSeriesClick(data) {

			const values = this.seriesesData.get(this.currentInterval);
			const examen = values.find(val => val.time == data.time)
			// this.$router.push(url);
			this.verRespuestasResultados(examen.tipo_contenido, examen.idexamen, examen.idusuario)
		},

		updateInterval(newInterval) {
			this.$emit('update:currentInterval', newInterval);
		},



		createTooltipContent(data) {
			return `
		<div class="tooltip-content">
			<div class="tooltip-title">${data.title}</div>
			<div class="tooltip-subtitle">Código: ${data.code}</div>
			<div class="tooltip-value">${data.correct} preguntas correctas de ${data.total}</div>
		</div>
		`;
		},

		convertToLiteral(num_prom) {
			let literal_prom = "";
			console.log(num_prom, "numd");
			if (num_prom > 17 && num_prom <= 20) {
				literal_prom = "AD"
			} else if (num_prom > 13 && num_prom <= 17) {
				literal_prom = "A"
			} else if (num_prom > 10 && num_prom <= 13) {
				literal_prom = "B"
			} else if (num_prom <= 10) {
				literal_prom = "C"
			}

			return literal_prom
		},


		calculateValuesTopTooltip() {
			let currentValues = this.seriesesData.get(this.currentInterval);
			if (!currentValues || !currentValues.length) {
				this.tooltipContent.promedio = ""
				this.tooltipContent.promedio_literal = ""
				this.tooltipContent.results = ""
				this.tooltipContent.rights = ""
				this.tooltipContent.total_questions = ""
				return
			}
			// console.log(currentValues, "gaaa");
			currentValues = currentValues.map(cu => cu.value)
			let sum = currentValues.reduce((acc, curr) => acc + curr);
			this.tooltipContent.promedio = sum / currentValues.length
			this.tooltipContent.promedio_literal = this.convertToLiteral(sum / currentValues.length)
			console.log(this.tooltipContent.promedio_literal, "mdpñasmpñl");
			let rights = 0;
			let questions = 0;
			this.dataGraph.forEach(cur => {
				rights += Number(cur.verdaderas)
				questions += Number(cur.cantidad_preguntas)
			});
			// console.log(rights, questions, "sdafs");
			// let sumQues= totalQuestions.reduce((acc, curr) => acc + curr);
			this.tooltipContent.results = `${rights} respuestas correctas de ${questions} preguntas`
			this.tooltipContent.rights = rights;
			this.tooltipContent.total_questions = questions;

		},

		// eslint-disable-next-line no-unused-vars
		verClase(idclase, perfil) {
			if (sessionStorage.licencia_perfil == "estudiante") this.$router.push(`/alumnoClase/${idclase}`);
			// if(sessionStorage.licencia_perfil == "familiar")  this.$router.push(`/clasesAlumnoFamilia/${idclase}`);
			else {
				this.setEnviarMens({
					tipo: "W",
					mensaje: "Su perfil no puede visualizar el módulo de clases",
					tiempo: 3000,
				});
			}

		},

		// funcionalidad de marcadores pendiente
		addAutomaticTimeScaleMarkers() {
			let previousDay = null;
			const markers = [];
			const data = this.seriesesData.get(this.currentInterval);

			if (data && data.length) {
				data.forEach((point) => {
					const currentDate = new Date(point.time * 1000);
					console.log(currentDate, "currentDate");
					if (previousDay !== currentDate.getUTCDate()) {
						markers.push({
							time: point.time,
							color: 'red',
							position: 'aboveBar',
						});
						previousDay = currentDate.getUTCDate();
					}
				});

				markers.forEach(marker => {
					this.chart.timeScale().addTimeScaleMarker(marker);
				});
			}
		},


		limpiarData() {
			this.additionalDataMap.clear();
		}

	},


	beforeDestroy() {
		if (this.chart) {
			this.chart.remove();
		}
	},
};
</script>

<style>
body {
	font-family: 'Trebuchet MS', Roboto, Ubuntu, sans-serif;
	background: #f9fafb;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.switcher {
	display: flex;
	align-items: center;
	height: 30px;
	margin-top: 8px;
	color: #2196F3;
}

.switcher-item {
	cursor: pointer;
	text-decoration: none;
	display: inline-block;
	padding: 6px 8px;
	font-size: 14px;
	color: #262b3e;
	background-color: transparent;
	margin-right: 8px;
	border: none;
	border-radius: 4px;
	outline: none;
}

.switcher-item:hover {
	background-color: #f2f3f5;
}

.switcher-active-item {
	text-decoration: none;
	cursor: default;
	color: #262b3e;
}

.switcher-active-item,
.switcher-active-item:hover {
	background-color: #e1eff9;
}

.floating-tooltip-2 {
	display: none;
	position: absolute;
	padding: 10px;
	box-sizing: border-box;
	font-size: 12px;
	color: #131722;
	background-color: rgba(255, 255, 255, 0.9);
	text-align: left;
	z-index: 1000;
	border: 1px solid rgba(0, 150, 136, 1);
	border-radius: 4px;
	min-width: 120px;
	max-width: 200px;
	pointer-events: none;
	/* Elimina cualquier borde interno o sombra que podría estar causando el problema */
	box-shadow: none;
	border-collapse: separate;
}

/* .cornered-tooltip {
	display: block;
	position: absolute;
	top: 10px;
	right: 10px;
	padding: 6px;
	font-size: 12px;
	color: '#20262E';
	background-color: rgba(238, 231, 231, 0.87);
	text-align: left;
	z-index: 2;
	pointer-events: none;
} */

.axis-label {
	position: absolute;
	color: #555;
	font-size: 14px;
	padding: 1px;
}

.y-axis-label {
	top: 70%;
	left: 28.9%;
	transform: translate(-100%, -50%) rotate(-90deg);
	/* Ajusta para posicionar correctamente la leyenda del eje Y */
	transform-origin: left top;
	/* Asegúrate de que la rotación sea alrededor de la esquina superior izquierda de la etiqueta */
}

.x-axis-label {
	bottom: 18%;
	left: 50%;
	transform: translateX(-50%);
}
</style>